import FixtureLineupsSummary from "./FixtureLineupsSummary";
export default FixtureLineupsSummary;
